import { z } from 'zod';
/** Antwort des Gesundheitstests `GET /api/health`. */
export const healthSchema = z.object({
    status: z.literal('ok'),
    db: z.literal('ok'),
});
//# sourceMappingURL=health.js.map